import { InjectionToken } from '@angular/core';

/** Firestore compat instance from firebase.ts (collection().add, same write path as modular addDoc). */
export type SchoolCompatFirestore = {
  collection: (path: string) => { add: (data: Record<string, unknown>) => Promise<unknown> };
};

export const SCHOOL_FIRESTORE = new InjectionToken<SchoolCompatFirestore>('SCHOOL_FIRESTORE');
